<script setup lang="ts">
interface DropdownTitleProps {
    icon?: string;
    label: string;
}

defineProps<DropdownTitleProps>();
</script>
<template>
    <div class="ds-dropdown-title">
        <i v-if="icon" :class="`ti ti-${icon}`"></i>
        <span>{{ label }}</span>
    </div>
</template>
<style scoped lang="scss">
.ds-dropdown-title {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px;
    margin: 0;
    color: $text-soft-400;
    text-transform: uppercase;
    font-weight: 600;
    @include font-size-12;
    i {
        font-size: 18px;
    }
}
</style>
